export enum ExportTypes {
  Pdf = 'pdf',
  Csv = 'csv',
  EmailCsv = 'emailCsv',
  EmailPdf = 'emailPdf',
}
